import type { AddToBagVerificationComposedLabels } from '@hm-group/cart-compositions'
import { getLabelFromStorage } from '@pb/utils'

export const getAddToBagVerificationCompositionLabels = (): AddToBagVerificationComposedLabels => ({
  shoppingbagHeading: getLabelFromStorage('cart.page.shopping.bag'),
  productTile: {
    quantity: getLabelFromStorage('basket.page.quantity'),
    size: getLabelFromStorage('favourites.size'),
    fewPiecesLeft: getLabelFromStorage('favorites.bag.fewPieceLeft'),
    color: getLabelFromStorage('basket.page.color'),
    previousPrice: getLabelFromStorage('checkout.prior.price.label'),
    memberPrice: getLabelFromStorage('member.price'),
    discountedPriceAria: getLabelFromStorage('basket.page.discounted.price'),
    goToPdpAria: getLabelFromStorage('basket.page.go.to.pdp'),
  },
})
